import React from 'react';
import { LEADER_BOARD_SLIDER } from './Slider/constants';
import { LEADER_BOARD_DETAILS } from './RaceDetails/constants';
import { LEADER_BOARD_RACES_LIST } from './RacesList/constants';
import { componentService } from 'js/services/component.service';

export const LeaderBoardRaceDetails = React.lazy(() => import(/* webpackChunkName: "leaderboard" */ './RaceDetails'));
export const LeaderBoardRaceList = React.lazy(() => import(/* webpackChunkName: "leaderboard" */ './RacesList'));
export const LeaderBoardRaceSlider = React.lazy(() => import(/* webpackChunkName: "leaderboard" */ './Slider'));

componentService.registerPageComponents({
    [LEADER_BOARD_RACES_LIST]: LeaderBoardRaceList,
    [LEADER_BOARD_SLIDER]: LeaderBoardRaceSlider,
    [LEADER_BOARD_DETAILS]: LeaderBoardRaceDetails
});
